import React, { FC, Fragment } from 'react';
import { RowSection as RowSectionType } from 'features/document/documentSlice';
import ViewerRowSection from '../ViewerRowSection/ViewerRowSection';
import styles from './ViewerContentSection.module.css';

interface Props {
  rows: RowSectionType[];
}

const ViewerContentSection: FC<Props> = ({ rows }) => {
  return (
    <div className={styles.container}>
      <div className={styles.addSectionContainer}>
        <div className={styles.addSection} />
      </div>
      {rows.map(row => (
        <Fragment key={row.id}>
          <ViewerRowSection row={row} />
          <div className={styles.addSectionContainer}>
            <div className={styles.addSection} />
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default ViewerContentSection;
